import React from 'react';
import './LabMain.css';

function LabMain({ userId }) {
  return (
    <div className="LabMain">
      Sample Information Coming Soon

    </div>
  );
}
    
export default LabMain;
